import {ICADModel, ICADLayer, ICADOperationLayer} from "./interfaces";
import { LayerTypeEnum } from "./enums";

export class GlassLayerHelpers {


    public static GetAllGlassLayers(model: ICADModel|null, glassLayersOnly:boolean) :ICADLayer[] {
        if (!model?.layer) {
            return [];
        }
        return [...GlassLayerHelpers.GetAllLayersFromLayer(model.layer, glassLayersOnly)];

    }

    private static GetAllLayersFromLayer(layer: ICADLayer, glassLayersOnly:boolean): ICADLayer[] {
        const nestedLayers = layer.layers;
    
        if (nestedLayers.length > 0) {
            if (glassLayersOnly && layer.layerType !== LayerTypeEnum.Glass) {
                return [...nestedLayers.flatMap((nestedLayer) => GlassLayerHelpers.GetAllLayersFromLayer(nestedLayer, glassLayersOnly))];
            }else{
                return [layer, ...nestedLayers.flatMap((nestedLayer) => GlassLayerHelpers.GetAllLayersFromLayer(nestedLayer, glassLayersOnly))];
            }
        }
        
        if (glassLayersOnly && layer.layerType !== LayerTypeEnum.Glass) {
            return [];
        }

        return [layer];
    }

    public static GetGlassLayerVisualDepth(model: ICADModel|null, targetLayer: string) : number {

        if (!model?.layer || targetLayer === model.layer.name) {
            //DNE or is the top layer
            return 0; 
        }

        const layerDepth = GlassLayerHelpers.RecursiveGetGlassLayerVisualDepth(model.layer, targetLayer, 0);

        if (layerDepth === -1) {
            return 0;
        }
    
        return layerDepth;
                
    }

    private static RecursiveGetGlassLayerVisualDepth(currentLayer: ICADLayer, targetLayer: string, depth: number): number {
        if (currentLayer.name === targetLayer) {
            if (currentLayer.layerType === LayerTypeEnum.Grid)
                return depth + 1; //Grids should be one level deeper
            else 
                return depth
        }
    
        const nestedLayers = currentLayer.layers ?? [];
        for (const nestedLayer of nestedLayers) {
            const foundDepth = GlassLayerHelpers.RecursiveGetGlassLayerVisualDepth(nestedLayer, targetLayer, depth + 1);
            if (foundDepth !== -1) {

                    return foundDepth;          
            }
        }
        return -1; 
    }

    public static FlattenGlassLayers = (layer: ICADOperationLayer|undefined ): ICADOperationLayer[] => {
    
        const flattenGlassLayers: ICADOperationLayer[] = [];

        if (!layer) {
            return flattenGlassLayers;
        }

        GlassLayerHelpers.RecusiveFlattenGlassLayers(layer, flattenGlassLayers);

        return flattenGlassLayers;
      };

    private static RecusiveFlattenGlassLayers = (layer: ICADOperationLayer, flattenedLayers: ICADOperationLayer[] = []): ICADOperationLayer[] => {

        //We don't want to push an nested layer.
        const simpleLayer: ICADOperationLayer = {
          ...layer,
          layers: []
        };

        flattenedLayers.push(simpleLayer);
      
        for (let i = 0; i < layer.layers.length; i++) {
            GlassLayerHelpers.RecusiveFlattenGlassLayers(layer.layers[i], flattenedLayers);
        }

        return flattenedLayers;
    }

    public static GetDefaultedSelectedGlassLayer = (parentLayer: ICADOperationLayer|undefined, currentSelectedGlassLayerName:string|undefined): string => {
        
        if (!currentSelectedGlassLayerName)
        {
            currentSelectedGlassLayerName = "";
        }

        if (!parentLayer) {
            return  currentSelectedGlassLayerName ; 
        }

        let glassLayers = GlassLayerHelpers.FlattenGlassLayers(parentLayer)

        //Try to find if the current layer is selected
        let selectedLayerName = glassLayers.find((layer) => layer.name === currentSelectedGlassLayerName && layer.selected === true)?.name
       
        if (!selectedLayerName) {
            //The current selected layer is not selected, so we will try to find the first selected layer
            selectedLayerName = glassLayers.find((layer) => layer.selected === true)?.name
        }

        if (!selectedLayerName){
            //shouldn't be possible
            return currentSelectedGlassLayerName
        }

        return selectedLayerName; //If no layers are selected, return the first layer's name
       
    }


    public static FindGlassLayerByName(model: ICADModel|null, targetLayer: string) : ICADLayer|undefined {

        if (!model?.layer || targetLayer === model.layer.name) {
            //DNE or is the top layer
            return model?.layer; 
        }

        return GlassLayerHelpers.FindGlassLayerByNameRecursive(model.layer, targetLayer);        
    }

    private static FindGlassLayerByNameRecursive(currentLayer: ICADLayer, targetLayer: string): ICADLayer|undefined {
        if (currentLayer.name === targetLayer) {
            return currentLayer; 
        }
  
        const nestedLayers = currentLayer.layers ?? [];
        for (const nestedLayer of nestedLayers) {
            const glassLayer = GlassLayerHelpers.FindGlassLayerByNameRecursive(nestedLayer, targetLayer);
            if (glassLayer !== undefined) {
                return glassLayer;          
            }
        }
     
        return undefined
    }
      
}
